import React from 'react'
import { Checkbox } from "primereact/checkbox";

const ProCheckBox = ({id, name, checked, onChange, labelText, disabled})=>{
  const disabledClass = disabled?"p-disabled":""; 
    return (<div className="p-field-row p-col-12">
    <Checkbox className={disabledClass} inputId= {id} id={id} name={name} checked={checked} onChange={onChange}></Checkbox>
    <label className={disabledClass} htmlFor={id} style={{margin: '1rem'}}>
      {labelText}
    </label>
  </div>)

}

export default ProCheckBox;